import { render } from "./ViewOrder.vue?vue&type=template&id=4248c6a1"
import script from "./ViewOrder.vue?vue&type=script&lang=js"
export * from "./ViewOrder.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__